import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Read-only dialog showing the full detail of an imported survey
 * (question / respondent / attachment counts + state breakdown + AI analysis).
 * Styling relies only on existing global Bootstrap utilities and Material
 * dialog directives — no component-specific CSS.
 */
@Component({
  selector: 'app-survey-details-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './survey-details-dialog.component.html'
})
export class SurveyDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SurveyDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { survey: any }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
